<script>
export default {
    name: 'ServicePlanFeatureCalendahView',
};
</script>

<script setup>
import ServicePlanFeatureElementsArray
    from '@/components/payments/components/service-plan/components/features/components/elements/array.vue';
import { VIEW_LABEL } from '@/modules/calendah/constants.ts';

defineProps({
    feature: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <service-plan-feature-elements-array
        :feature="feature"
        :map="VIEW_LABEL"
        :unit="list => list.length > 1 ? 'views' : 'view'"
    />
</template>
